import * as React from 'react';

import { AnalyticsStore } from 'bernie-core';

import { OverFilteredModel } from 'models';

import { UitkEmptyState } from 'uitk-react-empty-state';

import { PlaybackFilter } from 'components/search/playback/playback-filter';

export interface OverFilterProps {
  analytics?: AnalyticsStore;
  overFilteredModel: OverFilteredModel;
}

export const OverFilter: React.FunctionComponent<OverFilterProps> = ({ analytics, overFilteredModel }) => {
  React.useEffect(() => {
    if (analytics && typeof analytics.trackEvent === 'function') {
      analytics.trackEvent('OverFilter.Display', 'Display', analytics.omnitureData);
    }
  }, []);

  if (
    !overFilteredModel ||
    !overFilteredModel.overFilteredContent ||
    !overFilteredModel.overFilteredContent.titleModel ||
    !overFilteredModel.overFilteredContent.subtitleModel
  ) {
    return null;
  }

  const { titleModel, subtitleModel } = overFilteredModel.overFilteredContent;

  const { icon, text: heading } = titleModel;
  const { text: body } = subtitleModel;

  if (!icon || !heading || !body) {
    return null;
  }

  return (
    <div className="uitk-card-separator-bottom all-b-margin-six all-b-padding-six" data-stid="over-filter-messaging">
      <UitkEmptyState icon={icon} heading={heading} body={body} />
      <PlaybackFilter centerPills={true} wrapPills={true} />
    </div>
  );
};
OverFilter.displayName = 'OverFilter';
